module.exports = __webpack_public_path__ + "static/media/TEN-BNB.fdffe4cb.svg";